import { render, staticRenderFns } from "./ThemeLocationDropdown.vue?vue&type=template&id=5aea08ec"
import script from "./ThemeLocationDropdown.vue?vue&type=script&lang=js"
export * from "./ThemeLocationDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports